import { brands } from 'Constants';

const links = {};
links[brands.ABCBS] = {
  link:
    'https://www.anthem.com/find-doctor/?dplid=sso.dpl.providerdirectory.search-criteria',
  website: 'anthem.com'
};
links[brands.ABC] = {
  link:
    'https://www.anthem.com/ca/find-doctor/?dplid=sso.dpl.providerdirectory.search-criteria',
  website: 'anthem.com'
};


links[brands.BCNY] = {
  link:
    'https://www.anthem.com/find-doctor/?dplid=sso.dpl.providerdirectory.search-criteria',
  website: 'anthem.com'
};
links[brands.BCBSNY] = {
  link:
    'https://www.anthem.com/ca/find-doctor/?dplid=sso.dpl.providerdirectory.search-criteria',
  website: 'anthem.com'
};


links[brands.EBCBS] = {
  link:
    'https://www.empireblue.com/find-doctor/?dplid=sso.dpl.providerdirectory.search-criteria',
  website: 'empireblue.com'
};
links[brands.EBC] = {
  link:
    'https://www.empireblue.com/find-doctor/?dplid=sso.dpl.providerdirectory.search-criteria',
  website: 'empireblue.com'
};

links[brands.Anthem_HK] = {
  link:
    'https://www.anthem.com/ca/find-doctor/?dplid=sso.dpl.providerdirectory.search-criteria',
  website: 'anthem.com'
};



links[brands.ABCV] = {
  link:
    'https://www.anthem.com/ca/find-doctor/?dplid=sso.dpl.providerdirectory.search-criteria',
  website: 'anthem.com'
};



export default state => {
     
  state.doctorURL = links[state.brandID]

};
